<template>
  <div>
    <el-dialog :visible.sync="selectDialogVisibleValue" @close="closeSelectDialog" width="400px"
               :close-on-click-modal="false"
               title="投资">
      <div class='radioDiv'>
        <el-radio v-model="radio" label="personal">个人投资</el-radio>
<!--        <el-radio v-model="radio" label="personal">个人投资</el-radio>-->
<!--        <el-radio v-model="radio" label="personal">个人投资</el-radio>-->
      </div>

      <div slot="footer">
        <el-button type="primary" @click="selectConfirm">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog v-if='radio==="personal"'
               :visible.sync="dialogVisibleValue" @close="closeDialog" width="900px"
               :close-on-click-modal="false"
               title="个人投资">
      <div class='dialogBody'>
        <el-row v-for='(item, key) in wealthList' :key='key' type='flex' justify='end' :gutter="20" style='margin: 20px 0'>
          <el-col :span='6' class='spanCol'>
            <span>{{item.name}}：</span>
          </el-col>
          <el-col :span='14'>
            <el-slider v-model="item.value" @change="sliderChange(item, key)" :format-tooltip="handleDelta"></el-slider>
          </el-col>
          <el-col :span='4'>
            <span>{{item.value}}%</span>
          </el-col>
        </el-row>
      </div>
      <div slot="footer">
        <el-button type="primary" @click="confirm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'InvestDialog',
  props: ['dialogVisible', 'params'],
  watch: {
    dialogVisible (val) {
      this.selectDialogVisibleValue = val
      if (val) {
        this.wealthList[0].value = this.params[this.blockIndex]["DEMAND_DEPOSIT_RATIO"] * 100
        this.wealthList[1].value = this.params[this.blockIndex]["BOND_DOMINATED_ASSET_RATIO"] * 100
        this.wealthList[2].value = this.params[this.blockIndex]["EQUITY_DOMINATED_ASSET_RATIO"] * 100
      }
    }
  },
  data() {
    return {
      blockIndex: 1,
      selectDialogVisibleValue: false,
      dialogVisibleValue: false,
      radio: 'personal',
      wealthList: [
        // {name: '月储蓄比例', value: 30 ,key: 'monthlySavingRatio'},
        {name: '流动性资产比例', value: 35, key: 'demandDepositRatio',
          tooltip: '流动性较高的资产，例如活期存款，货币基金，短期理财产品等。'},
        {name: '固定收益型资产比例', value: 40, key: 'bondDominatedAssetRatio',
          tooltip: '国债、公司债，债券型基金等风险较低，收益较稳定的资产。'},
        {name: '权益型资产比例', value: 25, key: 'equityDominatedAssetRatio',
          tooltip:'上市公司股票和未上市公司股权等风险较高，收益较不稳定的资产基金等。'},
        // {name: '退休年龄', value: 65},
      ],
      sliderObj: {
        lockIdx: 2,
        lastLockIdx: 0,
      }
    }
  },
  methods: {
    handleDelta (e) {
      return `${e}%`
    },
    sliderChange (item, idx) {
      const idxList = [0, 1, 2]
      let lockIdxList = [idx]
      let val = 100 - item.value
      let max_val
      if (this.sliderObj.lockIdx === idx){
        lockIdxList.push(this.sliderObj.lastLockIdx)
        val -= this.wealthList[this.sliderObj.lastLockIdx].value
        max_val = 100 - this.wealthList[this.sliderObj.lastLockIdx].value
      } else {
        lockIdxList.push(this.sliderObj.lockIdx)
        val -= this.wealthList[this.sliderObj.lockIdx].value
        max_val = 100 - this.wealthList[this.sliderObj.lockIdx].value
      }
      const changeIdx = idxList.filter(item => !lockIdxList.includes(item))[0]
      this.wealthList[changeIdx].value = val >=0 ? val : 0
      if (this.wealthList[idx].value > max_val) {
        this.wealthList[idx].value = max_val
      }
      if (this.sliderObj.lockIdx !== idx) {
        this.sliderObj.lastLockIdx = this.sliderObj.lockIdx
        this.sliderObj.lockIdx = idx
      }
    },
    selectConfirm () {
      this.selectDialogVisibleValue = false
      this.dialogVisibleValue = true
    },
    confirm () {
      const data = {
        "DEMAND_DEPOSIT_RATIO": this.wealthList[0].value / 100,
        "BOND_DOMINATED_ASSET_RATIO": this.wealthList[1].value / 100,
        "EQUITY_DOMINATED_ASSET_RATIO": this.wealthList[2].value /100
      }
      this.$emit('dialogConfirm', this.blockIndex, data)
      this.closeDialog()
    },
    closeSelectDialog () {
      this.selectDialogVisibleValue = false
      this.$emit('dialogVisibleChange', false)
    },
    closeDialog () {
      this.dialogVisibleValue = false
      this.$emit('dialogVisibleChange', this.dialogVisibleValue)
    },
  }
}
</script>

<style scoped>
.radioDiv {
  text-align: center;
  justify-content: center;
  align-items: center;
  display: flex;
}
.dialogBody {
  max-height: 460px;
}
</style>



// WEBPACK FOOTER //
// src/components/options/InvestDialog.vue